import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Link from '@/components/atoms/Link';
import { GridWrapper } from '../styles/gridElements';
import ButtonPrimary from './shared/buttons/ButtonPrimary';
import { colorPalette, fonts } from '../styles/styleGuide';
import { hex2rgb } from '../styles/utils';
import { fromBreakpoint, breakpointSizes } from '../styles/breakpoints';
import withMatch from '@/hocs/withMatch';
var CookieNotice = /*#__PURE__*/function (_PureComponent) {
  function CookieNotice() {
    var _this;
    _classCallCheck(this, CookieNotice);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CookieNotice, [].concat(args));
    _defineProperty(_this, "state", {
      show: false
    });
    _defineProperty(_this, "setVisibility", function (_ref) {
      var match = _ref.match,
        loggedIn = _ref.loggedIn;
      var cookies = document.cookie;
      if (!loggedIn && match.params.env === 'open' && !cookies.includes('acceptTerms=yes')) {
        _this.setState({
          show: true
        });
      } else {
        _this.setState({
          show: false
        });
      }
    });
    _defineProperty(_this, "handleClick", function () {
      _this.setState({
        show: false
      }, function () {
        document.cookie = 'acceptTerms=yes; expires=Thu, 31 Dec 2099 12:00:00 UTC';
      });
    });
    return _this;
  }
  _inherits(CookieNotice, _PureComponent);
  return _createClass(CookieNotice, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setVisibility(this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        renderWidth = _this$props.renderWidth,
        match = _this$props.match;
      var _match$params = match.params,
        projectSlug = _match$params.projectSlug,
        env = _match$params.env;
      return this.state.show ? __jsx(Bar, {
        "data-id": "components_CookieNotice_Bar"
      }, __jsx(GridWrapper, {
        "data-id": "components_CookieNotice_GridWrapper"
      }, __jsx(Message, {
        "data-id": "components_CookieNotice_Message"
      }, __jsx("span", {
        "data-id": "components_CookieNotice_span"
      }, "Homestudios gebruikt cookies om uw gebruikerservaring te verbeteren. Voor meer informatie bekijk onze", ' ', __jsx(StyledLink, {
        href: "/".concat(String(projectSlug), "/").concat(String(env), "/sectionpage/disclaimer"),
        "data-id": "components_CookieNotice_StyledLink"
      }, "disclaimer"), "."), __jsx(ButtonPrimary, {
        type: "button",
        label: "Accepteer",
        clickHandler: this.handleClick,
        buttonColor: "#fff",
        buttonHoverColor: colorPalette.darkBlue,
        labelColor: colorPalette.blue,
        labelHoverColor: "#fff",
        size: renderWidth < breakpointSizes.md ? 'small' : 'normal',
        "data-id": "components_CookieNotice_ButtonPrimary"
      })))) : null;
    }
  }]);
}(PureComponent);
export default withMatch(CookieNotice);
var Bar = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 15rem;\n  position: fixed;\n  z-index: 1;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  color: #fff;\n  background: ", ";\n  font-family: ", ";\n\n  > div {\n    flex-wrap: wrap;\n  }\n\n  ", ";\n"])), hex2rgb(colorPalette.blue, 0.9), fonts.primary, fromBreakpoint.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 80rem;\n\n    > div {\n      flex-wrap: initial;\n    }\n  "]))));
var Message = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  font-size: 14rem;\n\n  ", ";\n\n  > button {\n    margin-top: auto;\n  }\n\n  > span {\n    padding-right: 20rem;\n  }\n"])), fromBreakpoint.md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: 18rem;\n\n    > button {\n      margin-top: 0;\n      margin-left: auto;\n    }\n\n    > div {\n      flex-wrap: initial;\n    }\n  "]))));
var StyledLink = styled(Link)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-style: italic;\n  text-decoration: none;\n  color: #fff;\n\n  text-decoration: none;\n  border-bottom: 1rem solid transparent;\n  transition: color 0.2s ease-in-out, border-bottom 0.2s ease-in-out;\n\n  :hover {\n    border-bottom: 1rem solid #fff;\n  }\n"])));